"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperContainer = exports.ListItem = exports.DropdownContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getContainerAnimationName = function getContainerAnimationName() {
  return (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0; transform: translateY(-5px);\n  }\n  to {\n    opacity: 1; transform: translateY(0);\n  }\n"])));
};
var getContainerAnimation = function getContainerAnimation(_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-timing-function: ease-in;\n"])), getContainerAnimationName, theme.dropdownAnimationDuration);
};
var PopperContainer = exports.PopperContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.dropdownZIndex);
});
var DropdownContainer = exports.DropdownContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  max-height: ", ";\n  overflow: auto;\n  padding: ", ";\n  min-width: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.listItemBackground;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.dropdownBorderSize, " solid ").concat(theme.dropdownBorderColor);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.dropdownBorderRadius;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.dropdownShadow ? theme.dropdownShadow : "0 0 ".concat(theme.dropdownShadowBlurRadius, " 0 ").concat(theme.dropdownShadowColor);
}, getContainerAnimation, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.dropdownFontFamily);
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.dropdownFontSize);
}, function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.dropdownLineHeight);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.dropdownMaxHeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.dropdownPadding;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.dropdownWidth;
});
var ListItem = exports.ListItem = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  text-align: left;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.listItemPadding);
}, function (_ref14) {
  var theme = _ref14.theme,
    isSelected = _ref14.isSelected;
  return isSelected ? theme.listItemBackgroundSelected : theme.listItemBackground;
}, function (_ref15) {
  var theme = _ref15.theme;
  return "".concat(theme.listItemColor);
}, function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.listItemBackgroundHover);
});